<!-- 单视频播放 Pop 组件 -->
<template>
  <div v-if="status" class="back_mask">
    <div class="prop">
      <div class="title">{{ data.title }}</div>
      <div class="subhead">{{ data.subhead }}</div>
      <video class="video" :src="data.src" autoplay loop controls></video>
      <div class="close" @click="close()"></div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    data: Object,
    status: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    close() {
      this.$emit("close-pop", null);
      this.$store.commit("setImgListStatus", true);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类

.back_mask {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  .prop {
    .title {
      position: fixed;
      color: #b82528;
      font-size: 3.2vh;
      font-weight: bold;
      top: 9%;
      left: 7%;
    }
    .subhead {
      position: fixed;
      font-size: 3vh;
      color: #ffffff;
      font-weight: bold;
      top: 9%;
      left: 40%;
    }
    .video {
      position: fixed;
      top: 15.5%;
      left: 1.25%;
      width: 97.4%;
      height: 76.5%;
      object-fit: fill;
    }
    .close {
      width: 5vh;
      height: 5vh;
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/close.png");
      background-size: 100% 100%;
      position: absolute;
      right: 0vh;
      top: 4vh;
    }
    .close:hover {
      transform: scale(1.1, 1.1);
    }
    position: absolute;
    width: 110vh;
    height: 80vh;
    background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/prop_back.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
